import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

/**
 * Geri alınamaz işlemler için erişilebilir onay penceresi.
 * Odak pencerede tutulur, Esc ve arka plana tıklama vazgeçer, ilk odak "Vazgeç" düğmesindedir.
 */
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  warning,
  confirmText,
  cancelText,
  danger = false,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Transition appear show={Boolean(open)} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[10000]"
        onClose={() => {
          if (!loading) onClose();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-150"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md rounded-xl bg-[--btn-txt] border border-solid border-[--gr-3] p-6 shadow-xl text-left">
                <Dialog.Title className="text-lg font-semibold text-[--gr-9]">
                  {title}
                </Dialog.Title>
                {message && (
                  <Dialog.Description className="mt-2 text-sm text-[--tx-1]">
                    {message}
                  </Dialog.Description>
                )}
                {warning && (
                  <p className="mt-3 text-sm font-medium text-red-500">
                    {warning}
                  </p>
                )}

                <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                  <button
                    type="button"
                    onClick={onClose}
                    disabled={loading}
                    className="px-4 py-2.5 rounded-lg border border-solid border-[--gr-3] text-[--gr-9] hover:bg-[--gr-0] disabled:opacity-50"
                  >
                    {cancelText || t("confirm.cancel")}
                  </button>
                  <button
                    type="button"
                    onClick={onConfirm}
                    disabled={loading}
                    className={`px-4 py-2.5 rounded-lg text-white disabled:opacity-50 ${
                      danger
                        ? "bg-red-600 hover:bg-red-700"
                        : "bg-[--primary] hover:bg-[--primary-hover]"
                    }`}
                  >
                    {loading ? t("common.loading") : confirmText || t("confirm.yes")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmDialog;
